import src from "IMAGE";
export default { src, width: 126, height: 31, blurWidth: 0, blurHeight: 0};
